module.exports = __webpack_public_path__ + "img/biaoqian_xuexiao.ea72f8c2.png";